import { withInstall } from '/@/utils';
import ViewMenuComp from './src/components/ViewMenuContent.vue'
import SelectedViewMenuComp from './src/components/SelectedViewMenu.vue'
import SaveViewMenuComp from './src/components/SaveViewMenu.vue'
export const ViewMenu = withInstall(ViewMenuComp);
export const SelectedViewMenu = withInstall(SelectedViewMenuComp);
export const SaveViewMenu = withInstall(SaveViewMenuComp);